module.exports = __webpack_public_path__ + "static/img/qxLogo.286da37.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/qxLogo.png
// module id = WiQ6
// module chunks = 1